import { VehicleServiceStatus, VehicleStatus } from "protobuf/vehicle_service_pb";
import { VehiclesActions, VehiclesState } from "types/store";
import { VEHICLE_SERVICE_STATUS, VEHICLE_STATUS } from "utils/mapped-data";

const originalFilters = {
  Model: [],
  // "Service Status": Object.keys(VehicleStatus.Enum).map((key, index) => ({
  //   label: VEHICLE_STATUS[index as VehicleStatus.Enum],
  //   value: key,
  // })),
  "Functional Status": [
    { label: "ON", value: "ON" },
    { label: "OFF", value: "OFF" },
    { label: "OFFLINE", value: "OFFLINE" },
  ],
  "Service Status": Object.keys(VehicleServiceStatus.Enum).map((key, index) => ({
    label: VEHICLE_SERVICE_STATUS[index as VehicleServiceStatus.Enum],
    value: key,
  })),

  "Client": [],

};

const updatedFilters = {
  Partner: [],
  Model: [],
  "Functional Status": [],
  "Service Status": [],
  "Client": [],
};

const initialState: VehiclesState = {
  page: {
    selectedPage: 1,
    totalElements: 0,
    totalPages: 0,
  },
  filters: {
    original: originalFilters,
    updated: updatedFilters,
  },
  search: "",
  showbulkActionsVehicles: false,
  logsPage:  {
    selectedPage: 1,
    totalElements: 0,
    totalPages: 0,
  },
};

export default function vehiclesReducer(
  state: VehiclesState = initialState,
  action: VehiclesActions
): VehiclesState {
  switch (action.type) {
    case "SET_VEHICLES_TABLE":
      return { ...state, vehicles: action.payload };
    case "SET_MODELS":
      return { ...state, models: action.payload };
    case "SET_VEHICLES_SELECTED_PAGE":
      return {
        ...state,
        page: { ...state.page, selectedPage: action.payload },
      };
    case "SET_LOGS_SELECTED_PAGE":
      return {
        ...state,
        logsPage: { ...state.logsPage, selectedPage: action.payload },
      };
    case "SET_LOGS_TOTAL_PAGE":
        return { ...state, logsPage: { ...state.logsPage, ...action.payload } };
    case "SET_VEHICLES_TOTAL_PAGE":
      return { ...state, page: { ...state.page, ...action.payload } };
    case "SET_VEHICLES_ORIGINAL_FILTERS":
      return {
        ...state,
        filters: { ...state.filters, original: action.payload },
      };
    case "SET_VEHICLES_UPDATED_FILTERS":
      return {
        ...state,
        filters: { ...state.filters, updated: action.payload },
      };
    case "SET_VEHICLE_SEARCH":
      return {
        ...state,
        search: action.payload,
      };
    case "SET_VEHICLES_BULK_ACTIONS":
      return {
        ...state,
        showbulkActionsVehicles: action.payload,
      };
    case "SET_DROPDOWN_VEHICLES":
      return {
        ...state,
        dropdownVehicles: action.payload,
      };
    case "SET_DROPDOWN_FIRMWARE":
      return {
        ...state,
        dropdownFirmwares: action.payload,
      };
    case "SET_VEHICLE_CLIENTS":
      return {
        ...state,
        clients: action.payload,
      };
    case "SET_VEHICLE_KIOSKS":
      return {
        ...state,
        kiosks: action.payload,
      };
    case "SET_SELECTED_VEHICLE":
      return {
        ...state,
        selectedVehicle: action.payload,
      };
    case "SET_SELECTED_VEHICLES":
      return {
        ...state,
        selectedVehicles: action.payload,
      };
    case "SET_VEHICLE_COUNTS_WITH_STATUS":
      return {
        ...state,
        vehicleCountWithStatus: action.payload,
      };
      case "SET_TOTAL_RIDERS":
        return { ...state, totalRiders: action.payload };
        case "SET_TOTAL_ACTIVE_RIDERS":
          return { ...state, totalActiveRiders: action.payload };
       case "SET_TOTAL_MILEAGE":
        console.log("Mileage-----------:", action.payload);
        return { ...state, totalMileage: action.payload };
    case "SET_VEHICLE_ISSUES":
      return {
        ...state,
        issues: action.payload,
      };
    case "SET_VEHICLE_LOCATION_HISTORY":
      return {
        ...state,
        vehicleLogs: action.payload,
      };
    case "SET_VEHICLES_BULK_UPDATE":
      return { ...state, vehicles: action.payload };
    case "SET_VEHICLE_EMPTY":
      state = initialState
          return state
    default:
      return state;
  }
}
